import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { ClassroomInfo } from "../classroom/classroomSlice";
import { getBackendUrl, LoadStateInfo, loaded, loading, notStarted, error, failedResponse } from "../common";
import { getToken } from "../../features/user/UserAvatar";

export interface SchoolDptoState {
  state: LoadStateInfo;
  schoolId?: string;
  list?: ClassroomInfo[];
}

const initialState: SchoolDptoState = {
  state: notStarted(),
};


export interface RetrieveSchoolDptoRequest {
  schoolId: string;
}
export const retrieveSchoolDpto = createAsyncThunk(
  "retrieveSchoolDpto",
  async (param: RetrieveSchoolDptoRequest, thunkAPI) => {
    console.debug(`retrieve dpto for school ${param.schoolId}`);

    const response = await fetch(`${getBackendUrl()}/api/school/${param.schoolId}/dpto`, {
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
      }
    });

    if(response.ok) {
      return await response.json();
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);


export const schoolDptosSlice = createSlice({
  name: "schoolDpto",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    clean: (state) => {
      state.state = notStarted();
      state.list = undefined;
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(retrieveSchoolDpto.pending, (state, action) => {
        state.state =  loading();
        state.list = undefined;
        state.schoolId = action.meta.arg.schoolId;
      })
      .addCase(retrieveSchoolDpto.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state =  loaded();
        state.list = action.payload;
        state.list?.sort((a, b) => (a?.name || "").localeCompare(b?.name || ""));
      })
      .addCase(retrieveSchoolDpto.rejected, (state, action) => {
        state.state = error(action);
      });
    },
});

export const { } = schoolDptosSlice.actions;

export const selectSchoolDptos = (state: RootState) => state.schoolDptos;

export default schoolDptosSlice.reducer;
